import logger from "../utils/logger";

const refreshTasks = async (loadTasks) => {
  if (typeof loadTasks !== 'function') return;
  await loadTasks();
};
export const handleCreateTask = async ({
  event,
  companyId,
  taskForm,
  getDefaultWorkspaceId,
  request,
  setTasksBusy,
  setStatus,
  setTaskForm,
  setTaskTagsInput,
  setTaskModalOpen,
  loadTasks,
  showStatus
}) => {
  event.preventDefault();
  if (!companyId) return;
  setTasksBusy(true);
  setStatus(null);
  try {
    const resultMetrics = (taskForm.result_metrics || []).filter(Boolean);
    const resultScope = taskForm.result_scope || 'assortment';
    const resultCabinetId = taskForm.result_cabinet_id || null;
    const resultSkus = Array.from(new Set((taskForm.result_skus || []).map(s => String(s || '').trim()).filter(Boolean)));
    const isSeoAiTask = taskForm.assignee_type === 'ai_agent' && taskForm.ai_agent_slug === 'seo';
    if (isSeoAiTask && !resultCabinetId) {
      throw new Error('Для SEO AI-задачи обязательно выберите кабинет в привязке к результату.');
    }
    if (isSeoAiTask && resultScope !== 'skus') {
      throw new Error('SEO AI-задача должна быть привязана к конкретному артикулу или группе артикулов.');
    }
    if (isSeoAiTask && resultSkus.length === 0) {
      throw new Error('Для SEO AI-задачи обязательно добавьте хотя бы один артикул.');
    }
    if (isSeoAiTask && resultMetrics.length === 0) {
      throw new Error('Для SEO AI-задачи обязательно выберите показатели результата.');
    }
    if (resultMetrics.length > 0 && !resultCabinetId) {
      throw new Error('Выберите кабинет для привязки результата.');
    }
    if (resultMetrics.length > 0 && resultScope === 'skus' && resultSkus.length === 0) {
      throw new Error('Для группы артикулов добавьте хотя бы один артикул.');
    }
    const payload = {
      company_id: companyId,
      workspace_id: taskForm.workspace_id || getDefaultWorkspaceId(),
      title: taskForm.title,
      description: taskForm.description,
      start_at: taskForm.start_at ? new Date(taskForm.start_at).toISOString() : null,
      due_at: taskForm.due_at ? new Date(taskForm.due_at).toISOString() : null,
      notify: taskForm.notify,
      tags: taskForm.tags || [],
      assignee_id: taskForm.assignee_type === 'ai_agent' ? null : taskForm.assignee_id || null,
      assignee_type: taskForm.assignee_type || 'user',
      ai_agent_slug: taskForm.assignee_type === 'ai_agent' ? taskForm.ai_agent_slug || null : null,
      co_assignee_ids: (taskForm.co_assignee_ids || []).filter(Boolean),
      watcher_ids: (taskForm.watcher_ids || []).filter(Boolean),
      cabinet_ids: (taskForm.cabinet_ids || []).filter(Boolean),
      result_scope: resultScope,
      result_cabinet_id: resultCabinetId,
      result_skus: resultScope === 'skus' ? resultSkus : [],
      result_metrics: resultMetrics,
      deal_id: taskForm.deal_id || null
    };
    await request('/api/v1/tasks/', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
    setTaskForm({
      title: '',
      description: '',
      start_at: '',
      due_at: '',
      notify: false,
      tags: [],
      workspace_id: taskForm.workspace_id || getDefaultWorkspaceId(),
      assignee_id: '',
      assignee_type: 'user',
      ai_agent_slug: '',
      co_assignee_ids: [],
      watcher_ids: [],
      cabinet_ids: [],
      result_scope: 'assortment',
      result_cabinet_id: '',
      result_skus: [],
      result_metrics: [],
      deal_id: ''
    });
    setTaskTagsInput('');
    setTaskModalOpen(false);
    await refreshTasks(loadTasks);
    showStatus('success', 'Задача создана.');
  } catch (error) {
    logger.error(error);
    showStatus('error', `Не удалось создать задачу. ${error.message || ''}`.trim());
  } finally {
    setTasksBusy(false);
  }
};
export const loadTaskHistory = async ({
  taskId,
  request,
  setTaskHistory
}) => {
  if (!taskId) return;
  try {
    const history = await request(`/api/v1/tasks/${taskId}/history`, {});
    setTaskHistory(history || []);
  } catch (error) {
    logger.error(error);
    setTaskHistory([]);
  }
};
export const openTaskDetail = async ({
  taskId,
  request,
  setSelectedTask,
  setTaskDetailBusy,
  setTaskDescriptionExpanded,
  setTaskHistoryExpanded,
  setStatus,
  setTaskDetail,
  setTaskComments,
  setTaskHistory,
  showStatus
}) => {
  if (!taskId) return;
  setSelectedTask(taskId);
  setTaskDetailBusy(true);
  setTaskDescriptionExpanded(false);
  setTaskHistoryExpanded(false);
  setStatus(null);
  try {
    const detail = await request(`/api/v1/tasks/${taskId}`, {});
    const comments = await request(`/api/v1/tasks/${taskId}/comments`, {});
    const history = await request(`/api/v1/tasks/${taskId}/history`, {});
    setTaskDetail(detail);
    setTaskComments(comments || []);
    setTaskHistory(history || []);
  } catch (error) {
    logger.error(error);
    showStatus('error', `Не удалось загрузить задачу. ${error.message || ''}`.trim());
  } finally {
    setTaskDetailBusy(false);
  }
};
export const handleAddTaskComment = async ({
  event,
  selectedTask,
  taskDetail,
  taskCommentBody,
  taskCommentFiles,
  request,
  setTaskDetailBusy,
  setStatus,
  setTaskComments,
  setTaskHistory,
  setTaskCommentBody,
  setTaskCommentFiles,
  showStatus
}) => {
  event.preventDefault();
  if (!selectedTask || !taskCommentBody.trim() && !(taskCommentFiles || []).length) return false;
  setTaskDetailBusy(true);
  setStatus(null);
  try {
    const body = taskCommentBody.trim() || 'Вложение';
    const comment = await request(`/api/v1/tasks/${selectedTask}/comments`, {
      method: 'POST',
      body: JSON.stringify({
        body
      })
    });
    const files = taskCommentFiles || [];
    if (files.length > 0) {
      const formData = new FormData();
      files.forEach(file => formData.append('files', file));
      const firstCabinetId = taskDetail?.cabinets?.[0]?.marketplace_account_id;
      if (firstCabinetId) formData.append('cabinet_id', firstCabinetId);
      await request(`/api/v1/tasks/${selectedTask}/comments/${comment.id}/attachments`, {
        method: 'POST',
        body: formData
      });
    }
    const comments = await request(`/api/v1/tasks/${selectedTask}/comments`, {});
    const history = await request(`/api/v1/tasks/${selectedTask}/history`, {});
    setTaskComments(comments || []);
    setTaskHistory(history || []);
    setTaskCommentBody('');
    setTaskCommentFiles([]);
    return true;
  } catch (error) {
    logger.error(error);
    showStatus?.('error', `Не удалось отправить комментарий. ${error.message || ''}`.trim());
    return false;
  } finally {
    setTaskDetailBusy(false);
  }
};
export const handleDeleteTask = async ({
  taskDetail,
  confirmed,
  request,
  setTaskDetailBusy,
  setStatus,
  loadTasks,
  closeTaskDetail,
  showStatus
}) => {
  if (!taskDetail || !confirmed) return;
  setTaskDetailBusy(true);
  setStatus(null);
  try {
    await request(`/api/v1/tasks/${taskDetail.id}`, {
      method: 'DELETE'
    });
    await refreshTasks(loadTasks);
    closeTaskDetail();
    showStatus('success', 'Задача удалена.');
  } catch (error) {
    logger.error(error);
    showStatus('error', `Не удалось удалить задачу. ${error.message || ''}`.trim());
  } finally {
    setTaskDetailBusy(false);
  }
};
export const handleStatusChange = async ({
  taskId,
  status,
  request,
  setTaskDetailBusy,
  setStatus,
  setTaskDetail,
  loadTaskHistory,
  loadTasks,
  showStatus
}) => {
  if (!taskId) return;
  setTaskDetailBusy(true);
  setStatus(null);
  try {
    const updated = await request(`/api/v1/tasks/${taskId}/status`, {
      method: 'POST',
      body: JSON.stringify({
        status
      })
    });
    setTaskDetail(updated);
    await loadTaskHistory(taskId);
    await refreshTasks(loadTasks);
    showStatus('success', 'Статус задачи обновлен.');
  } catch (error) {
    logger.error(error);
    showStatus('error', `Не удалось обновить задачу. ${error.message || ''}`.trim());
  } finally {
    setTaskDetailBusy(false);
  }
};
export const handleExecuteAiTask = async ({
  taskId,
  request,
  setTaskDetailBusy,
  setStatus,
  setTaskDetail,
  loadTaskHistory,
  loadTasks,
  showStatus
}) => {
  if (!taskId) return;
  setTaskDetailBusy(true);
  setStatus(null);
  try {
    const updated = await request(`/api/v1/tasks/${taskId}/execute-ai`, {
      method: 'POST'
    });
    setTaskDetail(updated);
    await loadTaskHistory(taskId);
    await refreshTasks(loadTasks);
    showStatus('success', 'AI-задача поставлена в выполнение.');
  } catch (error) {
    logger.error(error);
    showStatus('error', `Не удалось запустить AI-задачу. ${error.message || ''}`.trim());
  } finally {
    setTaskDetailBusy(false);
  }
};
export const handleExecuteAiTasks = async ({
  companyId,
  workspaceId,
  request,
  setTasksBusy,
  setStatus,
  loadTasks,
  showStatus
}) => {
  if (!companyId) return;
  setTasksBusy(true);
  setStatus(null);
  try {
    const query = new URLSearchParams({ company_id: companyId });
    if (workspaceId) query.set('workspace_id', workspaceId);
    const result = await request(`/api/v1/tasks/execute-ai?${query.toString()}`, {
      method: 'POST'
    });
    await refreshTasks(loadTasks);
    const queuedCount = Number(result?.queued_count || 0);
    const skippedCount = Number(result?.skipped_count || 0);
    if (queuedCount > 0) {
      showStatus('success', `Запущено AI-задач: ${queuedCount}${skippedCount ? `. Пропущено: ${skippedCount}.` : '.'}`);
    } else {
      showStatus('info', 'Нет AI-задач, доступных для запуска.');
    }
  } catch (error) {
    logger.error(error);
    showStatus('error', `Не удалось запустить AI-задачи. ${error.message || ''}`.trim());
  } finally {
    setTasksBusy(false);
  }
};
export const handleUpdateTaskFields = async ({
  taskId,
  fields,
  request,
  setTaskDetailBusy,
  setStatus,
  taskDetail,
  setTaskDetail,
  loadTasks,
  showStatus
}) => {
  if (!taskId) return;
  setTaskDetailBusy(true);
  setStatus(null);
  try {
    const updated = await request(`/api/v1/tasks/${taskId}`, {
      method: 'PATCH',
      body: JSON.stringify(fields)
    });
    if (taskDetail?.id === taskId) setTaskDetail(updated);
    await refreshTasks(loadTasks);
  } catch (error) {
    logger.error(error);
    showStatus('error', `Не удалось обновить задачу. ${error.message || ''}`.trim());
  } finally {
    setTaskDetailBusy(false);
  }
};
export const handleUpdateTask = async ({
  event,
  taskDetail,
  taskEditForm,
  request,
  setTaskEditBusy,
  setStatus,
  setTaskDetail,
  loadTaskHistory,
  setTaskEditOpen,
  loadTasks,
  showStatus
}) => {
  event.preventDefault();
  if (!taskDetail) return;
  setTaskEditBusy(true);
  setStatus(null);
  try {
    const payload = {
      title: taskEditForm.title,
      description: taskEditForm.description,
      start_at: taskEditForm.start_at ? new Date(taskEditForm.start_at).toISOString() : null,
      due_at: taskEditForm.due_at ? new Date(taskEditForm.due_at).toISOString() : null,
      notify: taskEditForm.notify,
      tags: taskEditForm.tags || [],
      created_by_id: taskEditForm.created_by_id || null,
      workspace_id: taskEditForm.workspace_id || null,
      assignee_id: taskEditForm.assignee_type === 'ai_agent' ? null : taskEditForm.assignee_id || null,
      assignee_type: taskEditForm.assignee_type || 'user',
      ai_agent_slug: taskEditForm.assignee_type === 'ai_agent' ? taskEditForm.ai_agent_slug || null : null,
      co_assignee_ids: (taskEditForm.co_assignee_ids || []).filter(Boolean),
      watcher_ids: (taskEditForm.watcher_ids || []).filter(Boolean),
      cabinet_ids: (taskEditForm.cabinet_ids || []).filter(Boolean)
    };
    const updated = await request(`/api/v1/tasks/${taskDetail.id}`, {
      method: 'PATCH',
      body: JSON.stringify(payload)
    });
    setTaskDetail(updated);
    await loadTaskHistory(taskDetail.id);
    setTaskEditOpen(false);
    await refreshTasks(loadTasks);
    showStatus('success', 'Задача обновлена.');
  } catch (error) {
    logger.error(error);
    showStatus('error', `Не удалось сохранить задачу. ${error.message || ''}`.trim());
  } finally {
    setTaskEditBusy(false);
  }
};
